const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';
import { apiFetch } from './interceptor';
export const walletApi = {
  getWallet: async (token, userId) => {
    try {
      const response = await apiFetch(`${BASE_URL}/wallet/user/${userId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }, false);
      
      // Check if we got a redirected response (expired token)
      if (response && response.redirected) {
        console.log('Token expired during wallet fetch');
        return { redirected: true };
      }
      
      return response.json();
    } catch (error) {
      console.error('Error fetching wallet:', error);
      throw error;
    }
  },

  sendLoadTransaction: async (token, transactionPayload) => {
    try {
      const response = await apiFetch(`${BASE_URL}/loadrequests/manual-load`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(transactionPayload)
      });
      
      // Check if we got a redirected response (expired token)
      if (response && response.redirected) {
        console.log('Token expired during load transaction');
        return { redirected: true };
      }
      
      const data = await response.json();
      return { status: response.status, data };
    } catch (error) {
      console.error('Error sending load transaction:', error);
      throw error;
    }
  }
};
